import PrimaryMenuItem from '../model/PrimaryMenuItem.js';
import SecondaryMenuItem from '../model/SecondaryMenuItem';

// 第一層
const shop = new PrimaryMenuItem('Shop', 'shop');

// 第二層

const NopCommerce = new SecondaryMenuItem('NopCommerce', () => import('@/modules/nop/views/NopCommerce.vue'));
const CloudShopManagement = new SecondaryMenuItem('CloudShopManagement', () => import('@/modules/cloudshop/views/CloudShop.vue'));

// 註冊第二層
shop.RegisterChild(NopCommerce);
shop.RegisterChild(CloudShopManagement);

export default shop;
